import { normalizeLigacaoInformacoesLinhas } from '../lib/ligacaoInformacoes'
import type { Ligacao } from '../types/helpdeskLigacao'

/** Colunas da tabela + nome do usuário (public.profiles) que registrou o contato. */
export const brokerContactLogsSelect =
  '*,registered_by:profiles!helpdesk_broker_contact_logs_registered_by_user_id_fkey(name),commercial_contact_reason:helpdesk_commercial_contact_reasons!helpdesk_broker_contact_logs_commercial_contact_reason_id_fkey(name)'

function normalizeHorario(value: string | null | undefined): string {
  if (!value || typeof value !== 'string') return '00:00'
  const s = value.trim()
  if (s.length >= 5 && s[2] === ':') return s.slice(0, 5)
  return s
}

export type HelpdeskBrokerContactLogRow = {
  id: string
  broker_id: string
  broker_contact_id: string | null
  attended_contact_label: string | null
  contact_date: string
  contact_time: string
  call_direction: string
  contact_channel: string
  reason: string | null
  commercial_contact_reason_id?: string | null
  commercial_contact_reason?: { name: string | null } | null
  note_lines: string[] | null
  subject: string | null
  registered_by_user_id: string | null
  registered_by?: { name: string | null } | null
  contact_made?: boolean | null
  overall_feedback?: string | null
  created_at: string
  updated_at: string
}

function mapOverallFeedback(value: string | null | undefined): Ligacao['feedback_geral'] {
  if (value === 'positivo' || value === 'neutro' || value === 'negativo') return value
  return undefined
}

export function mapHelpdeskBrokerContactLogRow(row: HelpdeskBrokerContactLogRow): Ligacao {
  const registros = normalizeLigacaoInformacoesLinhas(row.note_lines)
  const tipo = row.call_direction === 'receptivo' ? 'receptivo' : 'ativo'
  const tipoContato = row.contact_channel as Ligacao['tipo_contato']

  const rbName = row.registered_by?.name
  const registeredByName =
    typeof rbName === 'string' && rbName.trim()
      ? rbName.trim()
      : rbName != null && String(rbName).trim()
        ? String(rbName).trim()
        : undefined

  const crName = row.commercial_contact_reason?.name
  const motivoNome =
    typeof crName === 'string' && crName.trim()
      ? crName.trim()
      : crName != null && String(crName).trim()
        ? String(crName).trim()
        : undefined
  const motivoLegado =
    typeof row.reason === 'string' && row.reason.trim() ? row.reason.trim() : undefined

  return {
    id: row.id,
    corretor_id: row.broker_id,
    registered_by_user_id: row.registered_by_user_id?.trim() || undefined,
    registered_by_name: registeredByName,
    contato_id: row.broker_contact_id ?? undefined,
    attended_contact_label: row.attended_contact_label ?? undefined,
    data: typeof row.contact_date === 'string' ? row.contact_date.slice(0, 10) : String(row.contact_date),
    horario: normalizeHorario(row.contact_time),
    assunto: row.subject ?? undefined,
    tipo,
    tipo_contato: tipoContato,
    teve_contato: row.contact_made !== false,
    feedback_geral: mapOverallFeedback(row.overall_feedback),
    commercial_contact_reason_id:
      row.commercial_contact_reason_id && String(row.commercial_contact_reason_id).trim()
        ? String(row.commercial_contact_reason_id).trim()
        : undefined,
    motivo: motivoNome ?? motivoLegado,
    registros,
    created_at: row.created_at,
    updated_at: row.updated_at,
  }
}
